import logo from '../resources/images/logo.png'


export default function Logo(
  props: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
) {
  return <img {...props} alt="logo" src={logo} />
}
